export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
}

export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '下载指南',
    slug: 'download-guide',
    description: '提供008pg国际App的详细下载安装教程，覆盖iOS和Android双平台操作指引。',
    icon: 'ri-download-cloud-2-line',
    articleCount: 12,
  },
  {
    id: 'cat-2',
    name: '使用教程',
    slug: 'tutorials',
    description: '从新手入门到进阶技巧，全面掌握008pg国际平台的各种功能与操作。',
    icon: 'ri-book-open-line',
    articleCount: 18,
  },
  {
    id: 'cat-3',
    name: '安全指南',
    slug: 'security',
    description: '了解账户安全防护知识，学习如何保护个人信息与资金安全。',
    icon: 'ri-shield-check-line',
    articleCount: 8,
  },
  {
    id: 'cat-4',
    name: '常见问题',
    slug: 'faq',
    description: '汇总用户常见问题与解答，快速解决使用过程中遇到的各类疑问。',
    icon: 'ri-question-answer-line',
    articleCount: 15,
  },
  {
    id: 'cat-5',
    name: '最新动态',
    slug: 'news',
    description: '第一时间获取008pg国际平台的最新资讯、版本更新与活动信息。',
    icon: 'ri-newspaper-line',
    articleCount: 22,
  },
  {
    id: 'cat-6',
    name: '行业资讯',
    slug: 'industry',
    description: '关注行业发展动态，了解最新趋势与技术前沿信息。',
    icon: 'ri-global-line',
    articleCount: 10,
  },
];

export const articles: Article[] = [
  {
    id: 'art-1',
    slug: 'ios-download-install-guide',
    title: 'iOS用户如何安全下载安装008pg国际App',
    excerpt: '详细讲解iPhone和iPad用户如何通过官方渠道安全下载并安装008pg国际App，确保账户与设备安全。',
    content: '',
    category: '下载指南',
    categorySlug: 'download-guide',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20with%20clean%20iOS%20interface%20displaying%20app%20download%20screen%2C%20minimalist%20white%20background%20with%20soft%20warm%20lighting%2C%20professional%20product%20photography%20style%2C%20clean%20composition%20with%20gentle%20shadows%2C%20technological%20yet%20inviting%20atmosphere&width=800&height=500&seq=article-ios-download&orientation=landscape',
    author: '008pg技术支持',
    publishDate: '2026-08-01',
    readTime: '5分钟',
    tags: ['iOS', '下载教程', '安装指南'],
  },
  {
    id: 'art-2',
    slug: 'android-download-install-guide',
    title: 'Android用户完整下载安装流程（2026最新版）',
    excerpt: '面向所有Android用户的详细下载安装指南，涵盖权限设置、安全验证等关键步骤，确保顺利安装。',
    content: '',
    category: '下载指南',
    categorySlug: 'download-guide',
    coverImage: 'https://readdy.ai/api/search-image?query=Android%20smartphone%20showing%20APK%20installation%20screen%20with%20permission%20settings%2C%20clean%20modern%20desk%20setup%20with%20warm%20ambient%20light%2C%20minimalist%20tech%20photography%20style%2C%20soft%20natural%20shadows%2C%20professional%20composition&width=800&height=500&seq=article-android-download&orientation=landscape',
    author: '008pg技术支持',
    publishDate: '2026-07-28',
    readTime: '6分钟',
    tags: ['Android', '下载教程', '安装指南'],
  },
  {
    id: 'art-3',
    slug: 'account-security-best-practices',
    title: '008pg国际账户安全防护最佳实践',
    excerpt: '学习如何设置强密码、开启双因素认证等安全防护措施，全面保障您的账户和资金安全。',
    content: '',
    category: '安全指南',
    categorySlug: 'security',
    coverImage: 'https://readdy.ai/api/search-image?query=Digital%20security%20concept%20with%20shield%20icon%20and%20lock%20symbols%20on%20a%20clean%20laptop%20screen%2C%20warm%20minimalist%20office%20background%2C%20soft%20golden%20lighting%2C%20professional%20cybersecurity%20visual%20style%2C%20clean%20composition&width=800&height=500&seq=article-security-practice&orientation=landscape',
    author: '008pg安全团队',
    publishDate: '2026-07-25',
    readTime: '7分钟',
    tags: ['账户安全', '密码保护', '双因素认证'],
  },
  {
    id: 'art-4',
    slug: 'new-user-quick-start',
    title: '008pg国际新用户快速上手指南',
    excerpt: '刚下载008pg国际App？这篇快速入门指南帮你5分钟内掌握核心功能，轻松开启精彩体验。',
    content: '',
    category: '使用教程',
    categorySlug: 'tutorials',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20app%20onboarding%20welcome%20screen%20with%20friendly%20interface%2C%20bright%20warm%20background%20with%20soft%20gradients%2C%20clean%20UI%20design%20showcase%2C%20professional%20app%20photography%20style%2C%20inviting%20atmosphere&width=800&height=500&seq=article-quick-start&orientation=landscape',
    author: '008pg产品团队',
    publishDate: '2026-07-22',
    readTime: '4分钟',
    tags: ['新手入门', '快速上手', '基础功能'],
  },
  {
    id: 'art-5',
    slug: 'v2608-update-highlights',
    title: '008pg国际App v2.6.08版本更新亮点速览',
    excerpt: '最新版本带来多项功能优化与体验升级，包括界面焕新、性能提升以及若干用户期待的新特性。',
    content: '',
    category: '最新动态',
    categorySlug: 'news',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20app%20update%20announcement%20visual%20with%20version%20number%20and%20new%20feature%20icons%2C%20clean%20tech%20presentation%20background%20with%20warm%20gradients%2C%20professional%20software%20update%20marketing%20style%2C%20soft%20lighting%2C%20minimalist%20design&width=800&height=500&seq=article-update-highlights&orientation=landscape',
    author: '008pg产品团队',
    publishDate: '2026-07-20',
    readTime: '3分钟',
    tags: ['版本更新', '新功能', '产品动态'],
  },
  {
    id: 'art-6',
    slug: 'common-issues-troubleshooting',
    title: '008pg国际常见问题排查与解决方案汇总',
    excerpt: '整合用户反馈最多的技术问题与解决方案，涵盖登录异常、闪退修复、网络连接等高频问题。',
    content: '',
    category: '常见问题',
    categorySlug: 'faq',
    coverImage: 'https://readdy.ai/api/search-image?query=Technical%20support%20concept%20with%20question%20mark%20icons%20and%20solution%20pathways%20on%20a%20clean%20digital%20display%2C%20warm%20modern%20office%20setup%2C%20helpful%20customer%20service%20atmosphere%2C%20professional%20tech%20support%20visual%20style&width=800&height=500&seq=article-troubleshooting&orientation=landscape',
    author: '008pg技术支持',
    publishDate: '2026-07-18',
    readTime: '8分钟',
    tags: ['问题排查', '故障修复', '技术支持'],
  },
];

export const articleContents: Record<string, string> = {
  'art-1': `<h2>为什么选择官方渠道下载？</h2><p>在下载008pg国际App时，选择正确的下载渠道至关重要。官方渠道不仅保证您获得的是正版软件，更能确保应用没有被恶意篡改或植入病毒。本文将详细介绍iOS用户如何安全下载安装008pg国际App。</p><h2>下载前准备</h2><p>在开始下载之前，请确认您的iPhone或iPad满足以下条件：系统版本为iOS 12.0或更高版本，设备存储空间至少200MB可用，网络连接稳定。建议在Wi-Fi环境下进行下载以获得更快速度。</p><h2>步骤一：访问官方网站</h2><p>打开Safari浏览器，在地址栏输入008pg国际官方网站地址。请仔细核对网址是否正确，谨防钓鱼网站。进入官网后，您将在首页显著位置看到iOS下载入口。</p><h2>步骤二：点击iOS下载按钮</h2><p>在网站首页点击"iOS下载"按钮，系统将自动跳转至App Store中的008pg国际应用页面。如果您已在App Store登录Apple ID，可以直接点击"获取"按钮开始下载。</p><h2>步骤三：完成安装与信任设置</h2><p>下载完成后，应用将自动安装到您的设备上。首次打开时，系统可能会提示"未受信任的企业级开发者"。此时请前往"设置 > 通用 > VPN与设备管理"，找到对应的企业级应用证书，点击"信任"即可正常使用。</p><h2>安全提示</h2><p>请务必只通过官方渠道下载008pg国际App。切勿通过第三方应用市场、不明链接或他人分享的安装包进行下载，这些渠道可能含有恶意代码，威胁您的账户安全和个人隐私。</p>`,
  'art-2': `<h2>Android用户下载须知</h2><p>Android系统因其开放性，下载渠道更加多样化，但也带来了更多的安全风险。本文将指导您安全完成008pg国际App的下载与安装。</p><h2>系统要求检查</h2><p>请确保您的Android设备运行Android 8.0或更高版本系统，存储空间充足（建议保留300MB以上），并且已经开启"允许安装未知来源应用"的权限设置。</p><h2>步骤一：访问官网获取APK</h2><p>使用手机浏览器访问008pg国际官方网站，在首页找到"Android下载"按钮并点击。系统将自动下载最新的APK安装包文件到您的设备。</p><h2>步骤二：安装权限设置</h2><p>下载完成后，点击通知栏中的下载完成提示或进入文件管理器找到APK文件。系统会提示需要开启"允许安装未知来源应用"权限，请根据提示前往设置页面开启对应权限。</p><h2>步骤三：完成安装</h2><p>权限设置完成后，返回安装界面点击"安装"按钮，等待安装进度条完成即可。安装成功后，您可以在桌面找到008pg国际的图标。</p><h2>步骤四：安全验证</h2><p>首次启动应用时，建议检查应用的数字签名信息，确保与官方公布的签名一致。这一步骤能有效防止安装被篡改的版本。</p>`,
  'art-3': `<h2>账户安全的重要性</h2><p>在数字化时代，账户安全是每位用户都应重视的问题。008pg国际平台始终将用户安全放在首位，同时我们也建议用户主动采取以下安全措施。</p><h2>设置高强度密码</h2><p>建议使用至少12位字符的密码，包含大小写字母、数字和特殊符号的组合。避免使用生日、手机号等容易被猜测的信息作为密码。定期更换密码也是良好的安全习惯。</p><h2>开启双因素认证</h2><p>双因素认证（2FA）是为账户增加的第二道安全防线。即使密码不慎泄露，攻击者也难以通过第二重验证。008pg国际支持短信验证码和认证器App两种双因素认证方式。</p><h2>警惕钓鱼攻击</h2><p>不法分子可能通过伪装成官方的邮件、短信或社交媒体消息诱导您点击恶意链接。请记住：008pg国际官方永远不会通过非官方渠道索要您的密码或验证码。</p><h2>定期检查登录记录</h2><p>在App的"安全中心"中，您可以查看最近的登录记录。如发现可疑的异地登录或设备登录，请立即修改密码并联系客服处理。</p>`,
  'art-4': `<h2>欢迎加入008pg国际</h2><p>恭喜您完成下载安装！这篇快速指南将帮助您在最短时间内熟悉008pg国际的核心功能和操作方式。</p><h2>第一步：注册账户</h2><p>打开应用后，点击"注册"按钮，按照提示输入手机号码或邮箱地址，设置登录密码，并完成短信或邮箱验证。注册过程通常只需1-2分钟。</p><h2>第二步：完善个人信息</h2><p>登录后，建议前往"个人中心"完善您的头像、昵称等基本信息。完整的信息有助于获得更好的个性化服务和更高的账户安全等级。</p><h2>第三步：浏览核心功能</h2><p>008pg国际的首页展示了平台的核心功能入口。您可以依次浏览各个功能模块，了解每个功能的用途和操作方法。应用内配有详细的新手指引，跟着指引操作即可快速上手。</p><h2>第四步：设置安全选项</h2><p>进入"设置 > 安全中心"，建议立即开启双因素认证、设置支付密码等安全选项，为您的账户添加多重保护。</p>`,
  'art-5': `<h2>v2.6.08版本概览</h2><p>008pg国际App最新版本v2.6.08已正式发布，本次更新聚焦于用户体验优化和性能提升，以下是本次更新的主要内容。</p><h2>界面全面焕新</h2><p>我们对应用的整体视觉设计进行了全面升级，采用了更简洁现代的界面风格。导航结构更加清晰直观，重要功能更易于触达，整体操作流畅度显著提升。</p><h2>性能大幅优化</h2><p>本次更新针对应用启动速度、页面加载速度进行了深度优化。经测试，冷启动速度提升约40%，核心页面加载时间缩短30%，让您的使用体验更加丝滑顺畅。</p><h2>新增实用功能</h2><p>新增深色模式支持，夜间使用更护眼；新增消息中心，重要通知不再错过；优化搜索功能，支持模糊搜索和历史记录。</p><h2>安全加固</h2><p>更新了底层安全协议，修复了若干已知安全漏洞，进一步提升整体安全性。建议所有用户尽快更新至最新版本。</p>`,
  'art-6': `<h2>常见问题一站式解决方案</h2><p>我们整理了用户反馈频率最高的技术问题及其解决方案，帮助您快速自助排查和解决问题。</p><h2>登录失败怎么办？</h2><p>如遇到登录失败，请依次检查：网络连接是否正常、账号密码是否正确、是否开启了大小写锁定。如多次尝试仍无法登录，可使用"忘记密码"功能重置密码，或联系客服获取帮助。</p><h2>应用闪退如何处理？</h2><p>应用闪退通常可能与设备内存不足或应用缓存异常有关。建议先尝试清理后台应用释放内存，然后重启设备。如问题持续，可尝试在应用设置中清除缓存数据后重新启动应用。</p><h2>网络连接异常？</h2><p>切换Wi-Fi和移动数据网络尝试连接；检查是否开启了VPN或代理服务；重启路由器后再次尝试。如确认网络正常但仍无法连接，可能是服务器维护中，请稍后再试。</p><h2>更新失败的原因</h2><p>更新失败可能因为存储空间不足、网络不稳定或系统版本过低导致。请确保设备有充足的存储空间，在稳定的网络环境下重试更新操作。</p>`,
};